"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViolationType = exports.GeoShapeType = exports.Platform = exports.LogisticsClientType = exports.TripType = exports.TripState = void 0;
var TripState;
(function (TripState) {
    TripState["Pending"] = "pending";
    TripState["Created"] = "created";
    TripState["Accepted"] = "accepted";
    TripState["ConfirmedArrival"] = "confirmed_arrival";
    TripState["PickedUp"] = "picked-up";
    TripState["Dropped"] = "dropped";
    TripState["OTPConfirmed"] = "otp_confirmed";
    TripState["Completed"] = "completed";
    TripState["Incomplete"] = "incomplete";
    TripState["Cancelled"] = "cancelled";
})(TripState = exports.TripState || (exports.TripState = {}));
var TripType;
(function (TripType) {
    TripType["Lowbed"] = "lowbed";
    TripType["Lowboy"] = "lowboy";
    TripType["Recovery"] = "recovery";
    TripType["Pickup"] = "pickup";
    TripType["Bus"] = "bus";
    TripType["Flatbed"] = "flatbed";
    TripType["BoxTruck"] = "box-truck";
    TripType["DumpTruck"] = "dump-truck";
})(TripType = exports.TripType || (exports.TripType = {}));
var LogisticsClientType;
(function (LogisticsClientType) {
    LogisticsClientType["Tenderd"] = "tenderd";
    LogisticsClientType["Other"] = "other";
})(LogisticsClientType = exports.LogisticsClientType || (exports.LogisticsClientType = {}));
var Platform;
(function (Platform) {
    Platform["RMS"] = "rms";
    Platform["TrackWeb"] = "track-web";
    Platform["TrackMobile"] = "track-mobile";
    Platform["LogsiticsMobile"] = "logistics-mobile";
})(Platform = exports.Platform || (exports.Platform = {}));
var GeoShapeType;
(function (GeoShapeType) {
    GeoShapeType["Geofence"] = "geofence";
    GeoShapeType["Road"] = "road";
})(GeoShapeType = exports.GeoShapeType || (exports.GeoShapeType = {}));
var ViolationType;
(function (ViolationType) {
    ViolationType["OverSpeed"] = "overspeed";
    ViolationType["Idling"] = "idling";
    ViolationType["RouteDeviation"] = "route-deviation";
})(ViolationType = exports.ViolationType || (exports.ViolationType = {}));
//# sourceMappingURL=logistics.js.map